import { AppUser } from '@eventr/common'
import { ColoursObj, Typography } from '@eventr/common-storybook'
import { Box, Checkbox, Stack } from '@mui/material'
import i18n from '../../../i18n/i18next'
import { IOptionsWithTypes } from '../../../state/interfaces'
import { EditTeamMemberLine } from './EditTeamMemberLine'
import { checkIfUserSelected, filterBySearch } from './utils'
interface IUserListSectionProps {
    allUsers: AppUser[]
    membersList: IOptionsWithTypes[]
    userControlBox?: (user: any) => JSX.Element
    onRemoveUser: (users: AppUser[]) => void
    onAddUser: (users: AppUser[]) => void
    tagsToIgnore?: IOptionsWithTypes[]
    allowSelfRemove?: boolean
    ignoreTaggedUsers?: boolean
}
export const UserListSection = ({
    allUsers,
    membersList,
    userControlBox,
    onRemoveUser,
    onAddUser,
    tagsToIgnore,
    allowSelfRemove,
    ignoreTaggedUsers,
}: IUserListSectionProps) => {
    const otherUsers = allUsers.filter((user) => {
        if (tagsToIgnore && tagsToIgnore.length > 0) {
            if (user.groupTags.length === 0 && user.departmentTags.length === 0)
                return true
            let ignore = false
            tagsToIgnore.forEach((tag) => {
                if (user.groupTags.includes(tag.option as string)) ignore = true
                if (user.departmentTags.includes(tag.option as string))
                    ignore = true
            })
            return !ignore
        }
        if (ignoreTaggedUsers) return true
        return user.groupTags.length === 0 && user.departmentTags.length === 0
    })

    const allSelected = otherUsers.every((user) => {
        return checkIfUserSelected(user.id, membersList)
    })
    return (
        <Stack width={'100%'} gap={'8px'}>
            {otherUsers.length > 0 && filterBySearch(otherUsers).length > 0 && (
                <>
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'auto 1fr auto',
                            alignItems: 'center',
                            width: '100%',
                            gap: '8px',
                            backgroundColor: ColoursObj.backgrounds.secondary,
                            borderRadius: '8px',
                        }}
                        onClick={() => {
                            if (allSelected) {
                                onRemoveUser(otherUsers)
                            } else {
                                onAddUser(otherUsers)
                            }
                        }}
                    >
                        <Box>
                            <Checkbox
                                id="edit-members-team-members-checkbox"
                                checked={allSelected}
                                sx={{ color: ColoursObj.core.primary }}
                            />
                        </Box>

                        <Box>
                            <Typography variant="bodyBold">
                                {i18n.t('team.members')}
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                margin: '8px',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                background: ColoursObj.backgrounds.card,
                            }}
                        >
                            <Typography
                                id="edit-members-team-members-checkbox-counter"
                                variant="bodyRegular"
                            >
                                {otherUsers.length ?? '0'}
                            </Typography>
                        </Box>
                    </div>

                    <Stack padding={'0px 0px 0px 8px'}>
                        {filterBySearch(otherUsers).map((orgUser, i) => (
                            <EditTeamMemberLine
                                id={'team-members-'}
                                membersList={membersList}
                                userControlBox={userControlBox}
                                onAdd={(u) => onAddUser([u])}
                                onRemove={(u) => onRemoveUser([u])}
                                key={i}
                                user={orgUser}
                                allowSelfRemove={allowSelfRemove}
                            />
                        ))}
                    </Stack>
                </>
            )}
        </Stack>
    )
}
